import type { ILocation } from '@sravni/types/lib/locations';

import { getCenters, getCurrentUserLocation, getLocationNameLocative } from '../selectors/locations';

import { useAppSelector } from './redux';

export const useCenters = (): ILocation[] => useAppSelector(getCenters);

export const useNameLocative = (locationId: number): ILocation['nameLocative'] =>
  useAppSelector(getLocationNameLocative(locationId));

export const useCurrentUserLocation = (): ILocation => useAppSelector(getCurrentUserLocation);
